import React from 'react';
import { Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import './index.scss';

// 桌面返回入口放在内容两侧的等宽留白内，不占用正文行。
const PageBack = ({ onBack, label = '返回', disabled = false, className = '' }) => (
  <div className={`pageBack ${className}`}>
    <Button type="text" shape="circle" icon={<LeftOutlined />} aria-label={label} title={label} disabled={disabled} onClick={onBack} />
  </div>
);

export default PageBack;
